// extracted by mini-css-extract-plugin
module.exports = {"Button":"UserSearchResults_Button__2nmaW"};